<template>
	<div id="save-preset-modal" class="modal-new hidden">
		<i id="btn-import-preset" class="material-icons" data-tippy-content="Import a Preset">publish</i>
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Save a Preset</span>

		<div class="dropdown-component control-selector">
			<div class="control-selector__label-container" :class="{ '--disabled': presets.length == 0 }">
				<span class="selected-control-name">{{ presetFolder.id ? presetFolder.name : "Select folder..." }}</span>
				<i class="material-icons">expand_more</i>
			</div>

			<div class="control-selector__items-container" style="display: none;">
				<span
					v-for="presetFolder in presets"
					@click="onFolderSelection(presetFolder)"
					:key="presetFolder.id"
					:data-index="presetFolder.id"
					:data-name="presetFolder.name"
				>
					{{ presetFolder.name }}
				</span>
			</div>

			<i @click="onAddingNewFolder" id="btn_modal-add-folder-save-preset" class="material-icons" data-tippy-content="New Folder">
				add_circle_outline
			</i>
		</div>

		<input type="text" v-model.trim="folderName" ref="folder" name="folder" placeholder="Folder" style="display: none" class="regex-check" />
		<input type="text" v-model.trim="presetName" name="name" placeholder="Name" class="regex-check" />
		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary" @click="savePreset">Save</button>
			<button type="button" class="modal-btn --cancel" data-modal-action="close-modal">Cancel</button>
		</div>
	</div>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			folderName: "",
			presetName: "",
		};
	},
	computed: {
		...mapGetters("UserFiles", ["presets", "presetFolder"]),
	},
	methods: {
		async savePreset() {
			window.UI.hideModal();

			let blocks = cloneDeep(window.lutify.getRawBlocksData());

			let presetData = {};
			if (this.presetFolder.id && this.folderName == "") presetData.folder_id = this.presetFolder.id;
			else {
				if (this.folderName == "") this.folderName = "New Folder";
				presetData.folderName = this.folderName;
			}

			if (this.presetName == "") this.presetName = `New Preset.${Date.now()}`;
			else this.presetName = `${this.presetName}.${Date.now()}`;
			presetData.presetName = this.presetName;

			presetData.file = new File([JSON.stringify(blocks)], presetData.presetName + ".json", {
				type: "application/json",
			});

			await this.$store.dispatch("UserFiles/postPreset", presetData).then(response => {
				window.presetsStore.setItem(response.id, blocks);
				window.UI.message.activate(`Preset Saved Successfully`);
                this.$store.dispatch('UI/setAnimationForAddingPreset');
            });

			this.$store.dispatch("UserFiles/fetchPresets");

			this.folderName = "";
			this.presetName = "";
		},

		onFolderSelection(folder) {
			this.$store.dispatch("UserFiles/selectPresetFolder", folder.id);
		},

		onAddingNewFolder() {
			window.UI.modals.presets.save.el.find('input[name="folder"]').show();
			setTimeout(() => {
                this.$refs.folder.focus();
			}, 100)
		},
	},
};
</script>

<style></style>
